<template>
    <v-dialog
            v-model="dialog"
            max-width="550"
            hide-overlay class="olw"
            persistent
    >
        <v-card dark :color="$store.state.color2" class="olw">
            <v-card-title>
                {{group.name}}
                <v-spacer></v-spacer>
                <v-btn icon small @click="close()"><v-icon>{{icons.close}}</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-text-field
                        outlined
                        label="Group Name"
                        v-model="group.name"
                ></v-text-field>
                <v-row>

                    <v-col cols="10" class="pl-3 subtitle-1 font-weight-light" >
                        Group is {{group.state.toUpperCase()}} and has {{group.count||0}} contacts.
                    </v-col>
                    <v-col cols="2" class="pr-3 subtitle-1 font-weight-light text-right">
                        <BaseDialog :title="group.name+' Contacts'" :icon="icons.list" text=" " scrollable >
                            <GroupContacts :group="group"  />
                        </BaseDialog>
                    </v-col>
                    <v-col cols="8" class="px-3 subtitle-1 font-weight-light py-0" >
                        Created: <FDate :d="group.created" />
                    </v-col>
                    <v-col cols="4" class="px-3 py-0 text-right" >
                        <InvoiceToGroup />
                    </v-col>
                    <v-col cols="12" class="px-3 subtitle-1 font-weight-light mb-5 py-0" >
                        Updated: <FDate :d="group.updatedAt" />
                    </v-col>

                    <!--ACTIVE GROUPS -->
                    <v-col xs="12"  class="px-3" v-if="group.state==='active'">
                        <v-btn class="elevation-0" small @click="confirmingarchive=true" v-if="!confirmingarchive" dark color="warning">
                            Archive <v-icon class="pl-2">{{icons.folder}}</v-icon>
                        </v-btn>
                        <v-btn class="elevation-0"  rounded   small @click="archiveGroup()" :loading="loading" v-else color="warning">
                            Confirm Archive<v-icon class="pl-2">{{icons.folder}}</v-icon>
                        </v-btn>
                    </v-col>

                    <v-col xs="10" class="px-3" v-else>
                        <v-btn class="elevation-0"   small @click="confirmingarchive=true" v-if="!confirmingarchive" :color="$store.state.coloron">
                            Activate <v-icon class="pl-2">{{icons.folder}}</v-icon>
                        </v-btn>
                        <v-btn class="elevation-0"  rounded  small @click="activateGroup()" :loading="loading" :color="$store.state.coloron" v-else>
                            Confirm Activate <v-icon class="pl-2">{{icons.folder}}</v-icon>
                        </v-btn>
                    </v-col>

                    <v-col cols="2" sm4>
                        <v-btn  text @click="confirmingarchive=false" v-if="confirmingarchive">
                            <span class="hidden-xs-only pr-2">Cancel</span>
                            <v-icon>{{icons.ban}}</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="$emit('close')">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn text :disabled="!group.name" :loading="saveloading" @click="renameGroup"  >Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import FDate from "../FDate";
  import BaseDialog from "../BaseDialog";
  import GroupContacts from "./GroupContacts";
  import InvoiceToGroup from "../../views/invoicing/InvoiceToGroup";
  export default {
    props:['group','dialog','showactive'],
    components: {InvoiceToGroup, GroupContacts, BaseDialog, FDate},
    name: "EditGroup",
    data() {
      return {
        newname:'',
        confirmingarchive:false,
        loading:false,
        saveloading:false,
        groupinfo:undefined
      }
    },
    mounted() {

    },
    computed: {
        ...mapState(['icons'])
    },
    watch:{

    },
    methods: {
      ...mapActions(['post']),
      ...mapMutations(['updateGroup']),
      async renameGroup(){
        this.saveloading =  true
        let data = {
          name: this.group.name,
          sortkey: this.group.sortkey,
          groupkey: this.group.sortkey,
          orgpartkey: this.$store.state.org.partkey
        }
        let res = await this.post({path:'api/groups/renamegroupv2',body:data})
        this.updateGroup(res)
        this.$emit('close');
        this.saveloading = false;
      },

      async archiveGroup () {
        let em = this;
        em.loading=true;
        let args = {
          url:this.$store.state.url + 'api/groups/archivev2',
          method:"POST",
          data:{
            orgkey:this.$store.state.org.partkey,
            sortkey:this.group.sortkey
          }
        }
        this.$store.dispatch('fetch',args).then(res=>{
          em.$store.commit('removeGroup',{sortkey:em.group.sortkey})
          em.confirmingarchive=false;
          em.loading=false;
          em.$emit('close');
        }).catch(e=>{console.log(e)})
      },

      async activateGroup () {
        let em = this;
        em.loading=true;
        let args = {
          url:this.$store.state.url + 'api/groups/activatev2',
          method:"PUT",
          data:{
            orgkey:this.$store.state.org.partkey,
            groupkey:this.group.sortkey}
        }
        this.$store.dispatch('fetch',args).then(async res=>{
          console.log(res)
          em.$store.commit('removeArchivedGroup',{sortkey:em.group.sortkey})
          em.confirmingarchive=false;
          em.loading=false;
          em.$emit('close');
        }).catch(e=>{console.log(e)})
      },

      close(){
        this.$store.commit('setActiveGroup',false);
        this.$emit('close');
      }
    }
  }
</script>

<style scoped>
    .olw{
        border:solid thin white
    }
</style>